/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-rest-params */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ContentStatusInterface } from '../../+models';
import { ModelApiBase, PolpoApi } from '../shared';

@Injectable({ providedIn: 'root' })
export class ContentStatusApi extends ModelApiBase {
  constructor(api: PolpoApi) {
    super(api, 'ContentStatusses');
  }

  find(params?): Observable<ContentStatusInterface[]> {
    const path = '';
    const httpParams = this._getHttpParams({ filter: params });
    return this.get<ContentStatusInterface[]>(path, httpParams);
  }
}
